import { render, staticRenderFns } from "./LiveClassScheduleDetail.vue?vue&type=template&id=3d13f196&scoped=true&"
import script from "./LiveClassScheduleDetail.vue?vue&type=script&lang=js&"
export * from "./LiveClassScheduleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13f196",
  null
  
)

export default component.exports